enum DropShippingRefundReason {
    BUYER_REFUND = "买家退款",

    ORDER_COMMIT_ERROR = "订单提交错误",

    OTHER = "其他原因",
}

export default DropShippingRefundReason;
